import React from "react";
import { Box, useTheme } from "@material-ui/core";

import SensorError from "./SensorError";
import SensorValue from "./SensorValue";
import { SENSOR_STATUS } from "../../../domain/sensor";

const SensorRow = ({
  sensor,
  sensorSettings,
  inactiveDevice,
  thresholdSensor,
  isDeviceReported
}) => {
  const theme = useTheme();
  const colorOverride = inactiveDevice ? theme.palette.grey.A200 : null;

  return (
    <Box flex={1} minWidth={0}>
      {sensor.status === SENSOR_STATUS.ERROR ? (
        <SensorError sensor={sensor} colorOverride={colorOverride} />
      ) : (
        <SensorValue
          sensorSettings={sensorSettings}
          sensor={sensor}
          colorOverride={colorOverride}
          thresholdSensor={thresholdSensor}
          isDeviceReported={isDeviceReported}
        />
      )}
    </Box>
  );
};

export default React.memo(SensorRow, (prevProps, nextProps) => {
  return (
    prevProps.sensor.id === nextProps.sensor.id &&
    prevProps.sensor.pct === nextProps.sensor.pct &&
    prevProps.sensor.value === nextProps.sensor.value &&
    prevProps.sensor.status === nextProps.sensor.status &&
    prevProps.sensor.threshold === nextProps.sensor.threshold &&
    prevProps.inactiveDevice === nextProps.inactiveDevice &&
    prevProps.sensorSettings === nextProps.sensorSettings &&
    prevProps.thresholdSensor === nextProps.thresholdSensor
  );
});
